import { InjectionToken } from '@angular/core';
import type { MatDialog } from '@angular/material/dialog';
import type { IConfigPerfil } from 'modelos';

/**
 * Abre el formulario de perfil para crear uno nuevo y devuelve el guardado (o
 * `undefined` si se canceló).
 *
 * El formulario vive en `dominio/catalogos` y otro dominio no puede importarlo:
 * se lo pasa `app.config.ts`, que lo carga recién al usarlo.
 */
export type CrearPerfil = (
  dialog: MatDialog,
  opciones: { idCliente?: string },
) => Promise<IConfigPerfil | undefined>;

export const CREAR_PERFIL = new InjectionToken<CrearPerfil | undefined>('crear perfil', {
  factory: () => undefined,
});
